import { useCallback, useState } from 'react';
import { asyncAttempt } from '@namespace/helpers';
import { useI18n } from '@namespace/i18n';
import { useNotifications } from '@namespace/notifications';
import { editIban } from '../../api/editIban';

type ApiParams = {
  old: string;
  new: string;
  service_id: number;
};

const BLOCKED_BY_RISK_ERROR_CODE = 'ext_pay_sys_err_9';
const REQUIRED_IBAN_LENGTH = 21;

export const useEditIban = () => {
  const [isFetching, setIsFetching] = useState(false);
  const { errorNotification, successNotification } = useNotifications();
  const { t } = useI18n();
  const updateIban = useCallback(
    async (params: ApiParams) => {
      if (params?.new.length !== REQUIRED_IBAN_LENGTH) {
        errorNotification(
          t('web.personaloffice.withdrawal.iban.failure.message')
        );
        return null;
      }

      setIsFetching(true);
      const [requestError, result] = await asyncAttempt(editIban, params);

      if (requestError) {
        const error =
          requestError.errorCode === BLOCKED_BY_RISK_ERROR_CODE
            ? 'web.personaloffice.withdrawal.iban.blocked.message'
            : 'web.personaloffice.withdrawal.iban.failure.message';
        errorNotification(t(error));
      } else {
        successNotification(
          t('web.personaloffice.withdrawal.iban.success.message')
        );
      }
      setIsFetching(false);
      return result;
    },
    [errorNotification, successNotification, t]
  );

  return {
    isFetching,
    updateIban
  };
};
